import API from "./api";
import { ShowProposalSubmitting, ShowProposalSuccess } from "./snackbar";
import OpenDialog from "./dialog";
import OpenErrorDialog from "./dialog_error";

const Harms = () => window.map_data.Harms.map(harm => harm.Term);

export default class extends HTMLElement {
    #button = null;

    connectedCallback () {
        this.#button = this.querySelector("button");

        this.#button.addEventListener("click", async (e) => {
            e.preventDefault();
            this.openDialog();
        });
    }

    openDialog () {
        const el = document.createElement("div");
        el.innerHTML = `
            <form id="propose-resource-form" method="dialog">
                <input type="text" required placeholder="Title" name="title" />
				<div>
					<label for="harms">Harms</label>
					${this.harmsSelectControlMarkup()}
				</div>
                <textarea required placeholder="General reasoning. How is this challenge novel?" name="reasoning"></textarea>
                <button type="submit" value="confirm">Propose new challenge</button>
            </form>
        `;

        const dialog = OpenDialog("Propose a new challenge", el.innerHTML);

        const handler = async (e) => {
            dialog.removeEventListener("close", handler);
            if (e.target.returnValue !== "confirm") {
                return;
            }
            e.target.returnValue = "";
            const form = e.target.querySelector("form#propose-resource-form");

            const formData = new FormData(form);

            ShowProposalSubmitting();

            const response = await API.proposeNewChallenge(
                formData.get("title"),
                formData.getAll("harms"),
                formData.get("reasoning"),
            );

            if (response.ok) {
                ShowProposalSuccess();
            } else {
                const errorData = await response.json();
                OpenErrorDialog(errorData);
                return;
            }

            return false;
        };

        dialog.addEventListener("close", handler);
    }

    harmsSelectControlMarkup () {
        const selectList = document.createElement("select");
        selectList.role = "new-harm-relation";
        selectList.name = "harms";
        selectList.id = "harms";
        selectList.multiple = true;

        Harms().forEach(harm => {
            const option = document.createElement("option");
            option.value = harm;
            option.text = harm;
            selectList.appendChild(option);
        });

        return selectList.outerHTML;
    }
}
